export default __webpack_public_path__ + "static/artist-840314c514afa6f29bbd15d457b05c29.mp4";